import type { TextareaHTMLAttributes } from 'react';
type Props = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'rows'> & {
  value: string;
  /** Minimale hoogte in regels. */
  minRows?: number;
};

/**
 * Een tekstveld dat precies zo hoog wordt als zijn inhoud, ongeacht lettertype of breedte.
 *
 * Een onzichtbare kopie van de tekst staat in dezelfde rastercel als het veld en bepaalt de
 * hoogte; het veld rekt mee. De browser rekent zelf de regelafbreking uit, dus er is geen
 * schatting op tekens per regel, geen meting in JavaScript en geen verspringing na het typen.
 * Wie `className` meegeeft, geeft lettertype en regelafstand aan veld én kopie tegelijk.
 */
export function AutoTextarea({
  value,
  minRows = 2,
  className = '',
  ...rest
}: Props) {
  return <div className="grid" data-id="element-5130" data-mp="3cemhlb6lk5c5">
      {/* De spatie houdt een lege laatste regel (na Enter) even hoog als in het veld. */}
      <span aria-hidden="true" className={`invisible whitespace-pre-wrap break-words ${className}`} style={{
      gridArea: '1 / 1'
    }} data-id="element-5131" data-mp="1al5801ywouer">
        {value}{' '}
      </span>
      <textarea {...rest} value={value} rows={minRows} className={`resize-none overflow-hidden ${className}`} style={{
      gridArea: '1 / 1'
    }} data-id="element-5132" data-mp="32wzzep87b5f2" />
    </div>;
}